namespace advisorop.components.meetinghub {
    export class MeetingDocumentUploaderController {
        meetingId: number;
        meetingGuid: string;
        onAllFilesUploaded: any;

        constructor(private meetingHubService: services.MeetingHubService) {

        }

        allFilesUploaded(): void {
            if (this.onAllFilesUploaded != undefined) {
                this.onAllFilesUploaded();
            }
        }

        $onInit(): void {
        }

    }

    class MeetingDocumentUploader implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                meetingId: '<',
                meetingGuid: '<',
                onAllFilesUploaded: '&',
            };
            this.controller = [`meetingHubService`, MeetingDocumentUploaderController];
            this.controllerAs = `vm`;
            this.templateUrl = `spa/meeting-hub-module/components/meeting-document-uploader.html`;
        }
    }
    angular.module(Constants.APP).component(`meetingDocumentUploader`, new MeetingDocumentUploader());
}